import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
    plugins: [createPersistedState()],
    state: {
      is_loading: false,
      is_logged_in: false,

      cart: {
        shipping_info: {},
        billing_info: {},
      },

      cartCount: 0,

      popup: {
        open: false,
        content: ''
      },

      message: {
        open: false,
        type: 'success',
        message: ''
      }
    },
    mutations: {
      setCart(state, cart) {
        state.cart = cart

        // get total cart qty
        let amount = 0
        cart.items.forEach((obj,key)=>{
          amount = obj.qty
        })
        state.cartCount = amount
      },

      setLoading (state, boolean) {
        state.is_loading = boolean
      },

      setPopup (state, data) {
        state.popup.open = data.open
        state.popup.content = data.content
      },

      setToastMessage (state, data) {
        state.message = data
      },

      setLogin (state) {
        state.is_logged_in = true
      },

      setLogout (state) {
        state.is_logged_in = false
        state.accountNumber = null
      }
    },
    getters: {},
    actions: {}
})



// WEBPACK FOOTER //
// ./resources/assets/frontend/js/store.js